'use client';

import { useEffect } from 'react';
import { GlobalStateProvider } from '../state/app';
import Modal from '../views/components/Modal';
import DeeplinkErrorModal from '../components/DeeplinkErrorModal';

// Only loaded when NEXT_PUBLIC_XSTATE_INSPECT=1 — use `npm run dev:inspect`
const inspectEnabled = process.env.NEXT_PUBLIC_XSTATE_INSPECT === '1';

function XStateInspector(): null {
  useEffect(() => {
    if (!inspectEnabled) return;
    let cleanup: (() => void) | undefined;
    import('@xstate/inspect').then(({ inspect }) => {
      const { disconnect } = inspect({ iframe: false });
      cleanup = disconnect;
    }).catch(() => {
      // Inspector unavailable — non-fatal
    });
    return () => cleanup?.();
  }, []);
  return null;
}

export function GlobalStateProviderWrapper({ children }: { children: React.ReactNode }) {
  return (
    <GlobalStateProvider devTools={inspectEnabled}>
      {inspectEnabled && <XStateInspector />}
      {children}
      <Modal />
      <DeeplinkErrorModal />
    </GlobalStateProvider>
  );
}

